<template>
  <div>
    <el-card class="box-card" style="width: 600px">
<!--      <div class="demo-fit" style="display: flex">
        <div class="block">
          <el-avatar shape="square" :size="70" :src="user.avatarUrl"></el-avatar>
        </div>
        <div style="display: block">
        <div slot="header" class="clearfix" >
          <span style="font-size: 20px;">{{ user.nickname }}</span>
        </div>
        <div slot="header" class="clearfix" style="padding-left: 20px;">
          <span style="font-size: 10px;">{{ user.username }}</span>
        </div>
        </div>
      </div>
      <div>
        <div>学校：
          <el-tag>{{ user.schoolName }}</el-tag>
        </div>
        <div style="margin-top: 10px;">用户标签：
          <el-tag type="success" v-for="(r,index) in user.roles" :key="index">
            {{ r.nameZh }}
          </el-tag>
        </div>
        <div style="display: flex;justify-content: flex-end;margin-top: 10px;">
          <el-button type="danger" @click="showUpdatePasswordView">修改密码</el-button>
        </div>
      </div>-->
      <el-descriptions :colon="false" title="个人中心">
        <el-descriptions-item :colon="false">
          <el-avatar shape="square" :size="70" :src="user.avatarUrl"></el-avatar>
        </el-descriptions-item>
        <el-descriptions-item label="用户名:">{{ user.username }}</el-descriptions-item>
        <el-descriptions-item label="昵称:">{{ user.nickname }}</el-descriptions-item>
        <el-descriptions-item label="学校:">
          <el-tag size="small">{{ user.schoolName }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="用户标签:">
          <el-tag type="success" v-for="(r,index) in user.roles" :key="index">
            {{ r.nameZh }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>
      <div style="display: flex;justify-content: flex-end;margin-top: 10px;">
        <el-button type="danger" @click="showUpdatePasswordView">修改密码</el-button>
      </div>
    </el-card>
    <el-dialog
        title="修改密码"
        :visible.sync="dialogVisible"
        width="30%">
      <div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="旧密码" prop="oldPass">
            <el-input type="password" v-model="ruleForm.oldPass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="pass">
            <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  data() {
    const validateOldPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入旧密码'))
      } else {
        if (this.ruleForm.oldPass !== '') {
          this.$refs.ruleForm.validateField('pass')
        }
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      user: null,
      dialogVisible: false,
      ruleForm: {
        userId: '',
        oldPass: '',
        pass: '',
        checkPass: ''
      },
      rules: {
        oldPass: [{
          validator: validateOldPass,
          trigger: 'blur'
        }],
        pass: [
          {
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        checkPass: [
          {
            validator: validatePass2,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.initUser()
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 更新密码成功后退出登录
          this.ruleForm.userId = this.user.id
          this.putRequest('/pass', this.ruleForm).then(resp => {
            if (resp.code === 200) {
              this.postRequest('/logout')
              window.sessionStorage.removeItem('user')
              window.sessionStorage.removeItem('tokenStr')
              this.$store.commit('initRoutes', [])
              this.$router.replace('/login')
            }
          })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    showUpdatePasswordView() {
      this.dialogVisible = true
    },
    initUser() {
      this.getRequest('/info').then(resp => {
        if (resp) {
          this.user = resp
          // window.sessionStorage.setItem('user', JSON.stringify(resp))
          // this.$store.commit('initUser', resp)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
